import {Column} from 'react-table'
import {ContractPaymentActionsCell} from './ContractPaymentActionsCell'
import {ContractPayment} from '../../core/_models'
import {ContractPaymentReference} from './ContractPaymentReference'
import {ContractPaymentCustomHeader} from './ContractPaymentCustomHeader'
import {ContractPaymentOwners} from './ContractPaymentOwnersCell'
import {ContractPaymentAmountPaid} from './ContractPaymentAmountPaid'
import {ContractPaymentPayDay} from './ContractPaymentPayDay'
import {ContractPaymentObservations} from './ContractPaymentObservations'
import {ContractPaymentPaid} from './ContractPaymentPaid'

const ContractPaymentColumns: ReadonlyArray<Column<ContractPayment>> = [
  //HEADER COLUMN - Conditioning TYPE
  {
    Header: (props) => (
      <ContractPaymentCustomHeader
        tableProps={props}
        title='OWNERS.TITLE'
        className='fs-8 min-w-100px text-center flex-row-fluid flex-center'
      />
    ),
    id: 'owner',
    Cell: ({...props}) => <ContractPaymentOwners ContractPayment={props.data[props.row.index]} />,
  },

  //HEADER COLUMN - Conditioning TYPE
  {
    Header: (props) => (
      <ContractPaymentCustomHeader
        tableProps={props}
        title='CONTRACTS.REFERENCE_DATE'
        className='fs-8 min-w-100px text-center flex-row-fluid flex-center'
      />
    ),
    id: 'reference_date',
    Cell: ({...props}) => (
      <ContractPaymentReference ContractPayment={props.data[props.row.index]} />
    ),
  },

  //HEADER COLUMN - Conditioning TYPE
  {
    Header: (props) => (
      <ContractPaymentCustomHeader
        tableProps={props}
        title='CONTRACTS.PAYMENT_DATE'
        className='fs-8 min-w-100px text-center flex-row-fluid flex-center'
      />
    ),
    id: 'payday',
    Cell: ({...props}) => <ContractPaymentPayDay ContractPayment={props.data[props.row.index]} />,
  },

  //HEADER COLUMN - Conditioning TYPE
  {
    Header: (props) => (
      <ContractPaymentCustomHeader
        tableProps={props}
        title='CONTRACTS.AMOUNT_PAID'
        className='fs-8 min-w-100px text-center flex-row-fluid flex-center'
      />
    ),
    id: 'amount_paid',
    Cell: ({...props}) => (
      <ContractPaymentAmountPaid ContractPayment={props.data[props.row.index]} />
    ),
  },

  //HEADER COLUMN - Conditioning TYPE
  {
    Header: (props) => (
      <ContractPaymentCustomHeader
        tableProps={props}
        title='CONDITIONINGS.OBSERVATION'
        className='fs-8 min-w-100px text-center flex-row-fluid flex-center'
      />
    ),
    id: 'observations',
    Cell: ({...props}) => (
      <ContractPaymentObservations ContractPayment={props.data[props.row.index]} />
    ),
  },

  {
    Header: (props) => (
      <ContractPaymentCustomHeader
        tableProps={props}
        title='COMMON.STATUS'
        className='fs-8 min-w-50px text-center flex-row-fluid flex-center'
      />
    ),
    id: 'paid',
    Cell: ({...props}) => <ContractPaymentPaid ContractPayment={props.data[props.row.index]} />,
  },

  //HEADER COLUMN - ACTIONS
  {
    Header: (props) => (
      <ContractPaymentCustomHeader
        tableProps={props}
        title='MENU.ACTIONS'
        className='fs-8 text-center min-w-50px'
      />
    ),
    id: 'actions',
    Cell: ({...props}) => (
      <ContractPaymentActionsCell ContractPayment={props.data[props.row.index]} />
    ),
  },
]

export {ContractPaymentColumns}
